import { initialState, State } from 'mk2/containers/PregnancyCalculator/PregnancyCalculator.reducers';
import { AppState } from 'mk2/reducers';

export const getPregnancyCalculatorState = (state: AppState): State =>
    state.containers.wiki.pregnancyCalculator ?? initialState;
